/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import { CustomHeader, Screen, Text } from "components"
import React, { useCallback, useEffect, useState } from "react"
import {
  Animated,
  FlatList,
  Platform,
  ScrollView,
  TouchableOpacity,
  View,
  useWindowDimensions,
  Image,
} from "react-native"
import { style } from "./styles"
import { useFocusEffect, useNavigation } from "@react-navigation/native"
import MaterialIcons from "@expo/vector-icons/MaterialIcons"
import moment from "moment"
import LinearGradient from "react-native-linear-gradient"
import { translate } from "i18n"
import { useStores } from "models"
import { useSessionExpired } from "utils/function"
import { size } from "lodash"
import { colors } from "colors"
import useResponsiveWidth from "components/fitSize"
import flash from "config/flash"
import EmptyState from "components/EmptyState"
import { useColor } from "app/theme/getThemes"
import RenderHTML from "react-native-render-html"
import { typography } from "theme"
import StampItems from "components/StampItems"

export const StampsScreen = () => {
  const { userStore } = useStores()
  const { companyTheme } = useColor()

  const navigation = useNavigation<any>()
  // const { width } = useWindowDimensions()

  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()

  const { sessionExpired } = useSessionExpired()

  const [maxHeight] = useState(80)
  const [minHeight] = useState(Platform.OS === "web" ? 50 : 55)
  const [scrollY] = useState(new Animated.Value(0))

  const [filter, setFilter] = useState([
    { name: "COFFEE" },
    { name: "FOOD" },
    { name: "BEVERAGE" },
    { name: "SALES" },
  ])
  const [filterData, setFilterData] = useState([])
  //   const [redemption, setRedemption] = useState([])
  const [stamps, setStamps] = useState<any>([])

  useFocusEffect(
    useCallback(() => {
      getStamp()
    }, []),
  )

  const getStamp = async () => {
    await fetch(`${process.env.API_URL}/api/stamps/member/${userStore.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          const filterData = responseData?.filter((a: any) => a.status === "active")

          getStampsDetails(filterData)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreivePromotion"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreivePromotion"))
        console.error(e)
      })
  }

  const getStampsDetails = async (stampsList: any[]) => {
    try {
      const updatedStamps = await Promise.all(
        stampsList.map(async (stamp) => {
          try {
            const res = await fetch(
              `${process.env.API_URL}/api/stamp_list/member/${userStore?.id}/${stamp?.stamp_catalog_id}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${userStore?.accessToken}`,
                },
              },
            )

            if (!res.ok) {
              return { ...stamp, available_voucher_count: 0 }
            }

            const datas = await res.json()

            const redeemableVoucher = datas.filter(
              (a) => a.updated_status === "redeemable" && a.status === "active",
            ).length

            return { ...stamp, available_voucher_count: redeemableVoucher }
          } catch (error) {
            console.error("Error fetching stamp details:", error)
            return { ...stamp, available_voucher_count: 0 }
          }
        }),
      )

      console.log("updatedStamps", updatedStamps)

      // Update state with processed stamps
      setStamps(updatedStamps)
    } catch (error) {
      console.error(error)
    }
  }

  const toggleSelection = (selectedItem) => {
    setFilterData((prevSelected) => {
      // Check if the item is already selected
      if (prevSelected.some((item) => item.name === selectedItem.name)) {
        // Remove the item from selected items
        return prevSelected.filter((item) => item.name !== selectedItem.name)
      } else {
        // Add the item to selected items
        return [...prevSelected, selectedItem]
      }
    })
  }

  useFocusEffect(
    useCallback(() => {
      //   getRedemption()
    }, []),
  )

  const headerHeight = scrollY.interpolate({
    inputRange: [0, maxHeight - minHeight],
    outputRange: [maxHeight, minHeight],
    extrapolate: "clamp",
  })

  const [isMinimized, setIsMinimized] = useState(false)

  const handleScroll = Animated.event([{ nativeEvent: { contentOffset: { y: scrollY } } }], {
    useNativeDriver: false,
    listener: (event) => {
      const scrollOffset = event.nativeEvent.contentOffset.y
      setIsMinimized(scrollOffset > (maxHeight - minHeight) / 2)
    },
  })

  return (
    <>
      <CustomHeader headerTitle="My Stamps" />

      <Screen>
        <View style={style.container}>
          <ScrollView
            showsVerticalScrollIndicator={false}
            style={style.flex}
            scrollEventThrottle={16}
            onScroll={handleScroll}
          >
            <View style={style.flex}>
              <View style={style.mt15}>
                {/* <FlatList
                style={{ paddingLeft: "3%", paddingTop: "3%" }}
                data={filter}
                horizontal
                showsHorizontalScrollIndicator={false}
                renderItem={({ item }) => {
                  const isSelected = filterData.some((selected) => selected.name === item.name)

                  return (
                    <TouchableOpacity
                      onPress={() => toggleSelection(item)}
                      style={
                        isSelected
                          ? [
                              style.activeFilter,
                              {
                                borderColor: companyTheme.first,
                                backgroundColor: companyTheme.first,
                              },
                            ]
                          : [style.unactiveFilter, { borderColor: companyTheme.first }]
                      }
                    >
                      <Text
                        style={
                          isSelected
                            ? style.activeFilterText
                            : [style.unactiveFilterText, { color: companyTheme.first }]
                        }
                      >
                        {item?.name}
                      </Text>
                    </TouchableOpacity>
                  )
                }}
              /> */}

                <FlatList
                  style={[style.mt10, { paddingHorizontal: 10 }]}
                  data={stamps}
                  showsHorizontalScrollIndicator={false}
                  renderItem={({ item }) => {
                    const isExpired = moment().isAfter(moment(item?.end_date))

                    return (
                      <>
                        <StampItems stamps={item} isExpired={isExpired} />
                      </>
                    )
                  }}
                  ListEmptyComponent={() => {
                    return (
                      <View style={{ marginTop: 10 }}>
                        <EmptyState />
                      </View>
                    )
                  }}
                />
              </View>
            </View>
          </ScrollView>
        </View>
      </Screen>
    </>
  )
}
